'use strict';

var templates = require('../templates');
var fobclient = require('..');
var Kooperation = require('../entity').Kooperation;

module.exports = function (connection) {
  return {
    byAnsprechpartnerEquals: function byAnsprechpartnerEquals(ansprechpartner, additionalParams) {
      return templates.searchTemplate(connection)(Kooperation, 'byAnsprechpartnerEquals', 'ansprechpartner')(ansprechpartner, additionalParams);
    },
    byBeteiligteOrganisationenEquals: function byBeteiligteOrganisationenEquals(beteiligteorganisationen, additionalParams) {
      return templates.searchTemplate(connection)(Kooperation, 'byBeteiligteOrganisationenEquals', 'beteiligteorganisationen')(beteiligteorganisationen, additionalParams);
    },
    byEndeGeplantEquals: function byEndeGeplantEquals(endegeplant, additionalParams) {
      return templates.searchTemplate(connection)(Kooperation, 'byEndeGeplantEquals', 'endegeplant')(endegeplant, additionalParams);
    },
    byKooperationsTypEquals: function byKooperationsTypEquals(kooperationstyp, additionalParams) {
      return templates.searchTemplate(connection)(Kooperation, 'byKooperationsTypEquals', 'kooperationstyp')(kooperationstyp, additionalParams);
    },
    byKooperationsTypLike: function byKooperationsTypLike(kooperationstyp, additionalParams) {
      return templates.searchTemplate(connection)(Kooperation, 'byKooperationsTypLike', 'kooperationstyp')(kooperationstyp, additionalParams);
    },
    byKurzbeschreibungEquals: function byKurzbeschreibungEquals(kurzbeschreibung, additionalParams) {
      return templates.searchTemplate(connection)(Kooperation, 'byKurzbeschreibungEquals', 'kurzbeschreibung')(kurzbeschreibung, additionalParams);
    },
    byKurzbeschreibungLike: function byKurzbeschreibungLike(kurzbeschreibung, additionalParams) {
      return templates.searchTemplate(connection)(Kooperation, 'byKurzbeschreibungLike', 'kurzbeschreibung')(kurzbeschreibung, additionalParams);
    },
    byOrganisationseinheitEquals: function byOrganisationseinheitEquals(organisationseinheit, additionalParams) {
      return templates.searchTemplate(connection)(Kooperation, 'byOrganisationseinheitEquals', 'organisationseinheit')(organisationseinheit, additionalParams);
    },
    byRelevantFuerWeitereEquals: function byRelevantFuerWeitereEquals(relevantfuerweitere, additionalParams) {
      return templates.searchTemplate(connection)(Kooperation, 'byRelevantFuerWeitereEquals', 'relevantfuerweitere')(relevantfuerweitere, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(Kooperation, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    byTitelKooperationEquals: function byTitelKooperationEquals(titelkooperation, additionalParams) {
      return templates.searchTemplate(connection)(Kooperation, 'byTitelKooperationEquals', 'titelkooperation')(titelkooperation, additionalParams);
    },
    byTitelKooperationLike: function byTitelKooperationLike(titelkooperation, additionalParams) {
      return templates.searchTemplate(connection)(Kooperation, 'byTitelKooperationLike', 'titelkooperation')(titelkooperation, additionalParams);
    },
    byWeitereOrganisationseinheitenEquals: function byWeitereOrganisationseinheitenEquals(weitereorganisationseinheiten, additionalParams) {
      return templates.searchTemplate(connection)(Kooperation, 'byWeitereOrganisationseinheitenEquals', 'weitereorganisationseinheiten')(weitereorganisationseinheiten, additionalParams);
    },
    findAll: function findAll(page, additionalParams) {
      return templates.searchTemplate(connection)(Kooperation, 'findAll', 'page')(page, additionalParams);
    },
    findOne: function findOne(projection, additionalParams) {
      return templates.searchTemplate(connection)(Kooperation, 'findOne', 'projection')(projection, additionalParams);
    },
    forForschungsbericht: function forForschungsbericht(orgaid, additionalParams) {
      return templates.searchTemplate(connection)(Kooperation, 'forForschungsbericht', 'orgaid')(orgaid, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(Kooperation, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('kooperation')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/kooperation.js
// module id = HGgH
// module chunks = 0